import { type ServiceAddress } from './service-address';
import { type EmailInfo } from './email-info';
import { type PhoneInfo } from './phone-info';

export class Person {
  public FirstName?: string;
  public LastName?: string;
  public AccountNumber?: string;
  public PersonId?: string;
  public BillingAddress?: ServiceAddress;
  public PhoneNumbers?: PhoneInfo[] = [];
  public EmailAddresses?: EmailInfo[] = [];
}
